import {Injectable} from '@angular/core'
import {Title} from "@angular/platform-browser";
import {environment} from "../../environments/environment";
import {TranslateService} from "@ngx-translate/core";
import {BehaviorSubject} from "rxjs";

@Injectable({providedIn: 'root'})
export class TitleService {

  public title$: BehaviorSubject<string> = new BehaviorSubject<string>('')
  private currentTitleTranslationString?: string

  public setTitle(translationString: string, params?: {[key:string]: unknown}): void {
    this.currentTitleTranslationString = translationString;
    let title = ''

    if (!environment.production) {
      if (environment.env_name === 'local') {
        title += '🔴'
      }
      if (environment.env_name === 'local-stage') {
        title += '🟠'
      }
      if (environment.env_name === 'stage') {
        title += '🟢'
      }
      title += '[' + environment.env_name + '] ';
    }

    const translated = this.translate.instant(translationString, params);
    this.title$.next(translated);

    title += translated + ' - hello one';
    this.title.setTitle(title)
  }

  public constructor(
    private readonly title: Title,
    private readonly translate: TranslateService,
  ) {}
}
